import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToResults from 'components/_special/HowToResults'
import { ResizeContext } from 'contexts/Resize'
import { wgsResults } from 'routes'

import { SectionWrapperStyled } from './styles'

/**
 * DHowResults
 *
 * @param {object} props - properties of component
 * @returns {node} DHowResults
 */
const WHowResults = props => {
  const { index, data, pathCdn, locale, isSquareHidden } = props
  const link = wgsResults.link(locale)
  const asPath = wgsResults.as(locale)
  const viewport = React.useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapperStyled isOverflowHidden={true}>
      <HowToResults
        isSquareHidden={isSquareHidden}
        viewport={viewport}
        index={index}
        title={data.title}
        content={data.content}
        link={link}
        asPath={asPath}
        buttonText={data.button}
        pathCdn={pathCdn}
        data={data.list}
        squareColor={colors.macaroniAndCheese}
        isWhiteArrow={true}
        lineColor="light"
        textColor="light"
        buttonColor="purple"
        separatorColor={colors.whiteOp07}
        isLast
      />
    </SectionWrapperStyled>
  )
}

WHowResults.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

WHowResults.defaultProps = {
  isSquareHidden: false,
}

export default WHowResults
